import { BaseSurvey } from '../base-survey';
import { McmWebuiOptOutFeedbackView } from './view';
import { validateAccountSettingsTriggerCondition } from '../utils';

export class McmWebuiOptOutFeedbackSurvey extends BaseSurvey {
  getSurveyName = () => 'McmWebuiOptOutFeedbackSurvey';

  getSurveyId = isTestEnv => isTestEnv ? // eslint-disable-line no-confusing-arrow
    '455be049-493a-49f1-a076-8145a70ffa19' : '33bd3730-b4c6-4df8-8af2-b9662b83a64e';

  getSurveyProduct = () => 'ESC';

  getSurveyInterface = () => 'Web';

  validateTriggerCondition = () => validateAccountSettingsTriggerCondition(this, '/campaign/vnext/accountsettings', 'McmUserOptOut');

  onSurveySubmit = () => {
    window.survey.McmUserOptOut = false;
  };

  onSurveyDismiss = () => {
    window.survey.McmUserOptOut = false;
  };

  getSurveyComponent = () => McmWebuiOptOutFeedbackView;
}
